import uploadspracticeAreasfeaturesYourRightsfeature02Imagethe_biggest_mass_tort_cases_in_historyJpg from "$lib/data/generated/uploads/practice areas/Features Your Rights/Feature 02 Image/the_biggest_mass_tort_cases_in_history.jpg";

export const uploads = {
  "uploads/practice areas/Features Your Rights/Feature 02 Image/the_biggest_mass_tort_cases_in_history.jpg": uploadspracticeAreasfeaturesYourRightsfeature02Imagethe_biggest_mass_tort_cases_in_historyJpg
};